import { pure } from 'recompose';

const Body = () => null;

export default pure(Body);



// WEBPACK FOOTER //
// ./components/SimpleTable/Body.jsx